<template>
    <section v-if="isLoaded" class="quiz-finish-page">
        <div class="quiz-finish-container" v-if="hideAnswers">
          <div class="quiz-thankyou-card">
            <span class="quiz-thankyou-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            <div v-if="confirmationMessageHasHtml" class="text-center ck-content quiz-thankyou-message" v-html="quiz.confirmation_message"></div>
            <h1 v-else-if="quiz.confirmation_message" class="text-center empty-title quiz-thankyou-title">
              {{ quiz.confirmation_message }}
            </h1>
            <h1 v-else class="text-center empty-title quiz-thankyou-title">
              {{ trans('Form successfully submitted') }}
            </h1>
          </div>
        </div>
        <FormReport :id="this.id" v-else-if="quiz"></FormReport>
    </section>
</template>

<script>
import {mapMutations} from "vuex";
import FormReport from "./FormReport.vue";

export default {
    name: "Confirm",
    components: {FormReport},
    methods: {
        ...mapMutations(['fetchQuizReport', 'changeIsLoaded']),
    },

  computed: {
    id() {
      return this.$route.params.id;
    },

    hideAnswers() {
      return this.$store.state.hide_answers;
    },

    isLoaded() {
      if (this.$store.state?.isLoaded) {
        return this.$store.state?.isLoaded;
      }

      return false;
    },

    quiz() {
      return this.$store.state.activeQuiz;
    },

    confirmationMessageHasHtml() {
      const message = this.quiz.confirmation_message;

      return !!message && /<[a-z][\s\S]*>/i.test(message);
    },
  },

  beforeMount() {
    this.fetchQuizReport(this.id);
  },

  beforeDestroy() {
      this.changeIsLoaded();
  }
}
</script>
